//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TeacherEmailPreferencesDisplayItem extends ItemBase {
    AllowStudentsToEmailMeFromPracticeLog: boolean = false;
    NotifyWhenAnyFamilyMemberCompletesSignupForm: boolean = false;
    NotifyWhenAnyFamilyMemberDisablesEmailReminders: boolean = false;
    NotifyWhenAnyStudentCancelsEvent: boolean = false;
    NotifyWhenAnyStudentJoinsEvent: boolean = false;
    NotifyWhenAnyFamilyMemberAssignedToMeViaSignupForm: boolean = false;
    NotifyWhenMyStudentCancelsEvent: boolean = false;
    NotifyWhenMyStudentJoinsEvent: boolean = false;
    SendAgendaAtHour: number | null = null;
    SendAgendaForNoEvents: boolean = false;

    constructor(initializer?: Partial<TeacherEmailPreferencesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherEmailPreferencesDisplayItem";
}
